import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Facebook } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list. Welcome to Atelier Noir.");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    } finally { setLoading(false); }
  };

  return (
    <footer className="mt-32 bg-[#0A0A0A] text-white">
      {/* Newsletter */}
      <div className="border-b border-white/10 py-20 px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="overline text-[#C5A059]">The Atelier Letter</div>
            <h3 className="serif text-4xl lg:text-5xl mt-3 leading-tight">Receive our editorial,<br/> first looks &amp; private invitations.</h3>
          </div>
          <form onSubmit={subscribe} className="flex gap-0 border-b border-white/30">
            <input
              data-testid="newsletter-email-input"
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="bg-transparent flex-1 py-4 outline-none placeholder:text-white/40"
            />
            <button data-testid="newsletter-submit" disabled={loading} className="text-[0.7rem] tracking-[0.25em] uppercase hover:text-[#C5A059] transition-colors px-4">
              {loading ? "Sending" : "Subscribe →"}
            </button>
          </form>
        </div>
      </div>

      {/* Links */}
      <div className="max-w-[1400px] mx-auto py-16 px-6 lg:px-12 grid grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="serif text-2xl">Atelier Noir</div>
          <p className="mt-4 text-sm text-white/60 leading-relaxed">Modest fashion, premium hijabs, and bespoke handbags — handcrafted for the woman who chooses with intention.</p>
        </div>
        <div>
          <div className="overline text-white/60">Shop</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li><Link to="/shop/clothing">Women's Clothing</Link></li>
            <li><Link to="/shop/hijabs">Hijabs</Link></li>
            <li><Link to="/shop/bags">Bags</Link></li>
            <li><Link to="/shop/accessories">Accessories</Link></li>
            <li><Link to="/custom-bag">Bespoke Bag</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-white/60">Maison</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li><Link to="/about">Our Story</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/account">Account</Link></li>
            <li><Link to="/wishlist">Wishlist</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-white/60">Reach Us</div>
          <ul className="mt-4 space-y-3 text-sm text-white/80">
            <li>hello@atelier-noir.com</li>
            <li>+971 50 733 4979</li>
            <li>WhatsApp +971 50 733 4979</li>
          </ul>
          <div className="mt-6 flex gap-4">
            <a href="https://instagram.com/mohwaheeb" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="hover:text-[#C5A059]"><Instagram size={18} /></a>
            <a href="#" aria-label="Twitter" className="hover:text-[#C5A059]"><Twitter size={18} /></a>
            <a href="#" aria-label="Facebook" className="hover:text-[#C5A059]"><Facebook size={18} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-[0.65rem] tracking-[0.3em] uppercase text-white/40">
        © {new Date().getFullYear()} Atelier Noir — Crafted with intention
      </div>
    </footer>
  );
}
